import { render } from "./accessRequestClientList.vue?vue&type=template&id=6b3a769f&ts=true"
import script from "./accessRequestClientList.vue?vue&type=script&lang=ts&config=true"
export * from "./accessRequestClientList.vue?vue&type=script&lang=ts&config=true"

import "./accessRequestClientList.vue?vue&type=style&index=0&id=6b3a769f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__